import { useState } from 'react';
import Menu from '../../components/Menu/Menu';
import Footer from '../../components/Footer';
import Toast from '../../components/Toast';
import { sendTestEmail } from '../../services/EmailTestService';

function TestEmail() {
    const [to, setTo] = useState('');
    const [subject, setSubject] = useState('Email de teste - EasyCripto');
    const [message, setMessage] = useState('Este é um email de teste enviado pelo painel admin do EasyCripto.\n\nSe você recebeu esta mensagem, o envio de emails via MailerSend está funcionando corretamente.');
    const [loading, setLoading] = useState(false);
    const [notification, setNotification] = useState({ type: '', text: '' });

    function onSubmit(event) {
        event.preventDefault();
        setNotification({ type: '', text: '' });

        setLoading(true);
        sendTestEmail(to || undefined, subject || undefined, message || undefined)
            .then(result => {
                setNotification({ type: 'success', text: result.message || 'Email de teste enviado com sucesso!' });
            })
            .catch(err => {
                let errorMsg = 'Erro ao enviar email de teste';
                
                if (err.response?.data) {
                    const data = err.response.data;
                    if (typeof data === 'string') {
                        errorMsg = data;
                    } else if (data.message) {
                        errorMsg = data.message;
                        // Se tiver detalhes adicionais, adiciona
                        if (data.details && Array.isArray(data.details) && data.details.length > 0) {
                            const details = data.details.map(d => d.message || JSON.stringify(d)).join('; ');
                            errorMsg += ` (${details})`;
                        }
                    } else {
                        errorMsg = JSON.stringify(data);
                    }
                } else if (err.message) {
                    errorMsg = err.message;
                }
                
                setNotification({ type: 'error', text: errorMsg });
            })
            .finally(() => setLoading(false));
    }

    return (
        <>
            <Menu />
            <main className="content">
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                    <div className="d-block mb-4 mb-md-0">
                        <h1 className="h4">Teste de Envio de Email</h1>
                        <p className="mb-0 text-muted">
                            Use esta página para enviar um email de teste com as configurações atuais de MailerSend.
                        </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="card card-body border-0 shadow mb-4">
                            <h2 className="h5 mb-4">Enviar email de teste</h2>
                            <form onSubmit={onSubmit}>
                                <div className="row">
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="to" className="form-label">Para (destinatário)</label>
                                        <input
                                            id="to"
                                            type="email"
                                            className="form-control"
                                            placeholder="seu-email@exemplo.com (opcional, usa o email das configurações se vazio)"
                                            value={to}
                                            onChange={e => setTo(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 mb-3">
                                        <label htmlFor="subject" className="form-label">Assunto</label>
                                        <input
                                            id="subject"
                                            type="text"
                                            className="form-control"
                                            value={subject}
                                            onChange={e => setSubject(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 mb-3">
                                        <label htmlFor="message" className="form-label">Mensagem</label>
                                        <textarea
                                            id="message"
                                            className="form-control"
                                            rows="6"
                                            value={message}
                                            onChange={e => setMessage(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-3">
                                        <button
                                            type="submit"
                                            className="btn btn-gray-800 mt-2 animate-up-2"
                                            disabled={loading}
                                        >
                                            {loading ? 'Enviando...' : 'Enviar email de teste'}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <Footer />
            </main>
            <Toast type={notification.type} text={notification.text} />
        </>
    );
}

export default TestEmail;


